import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgReageren = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFEFE8"
      d="M24 10H10v14h14z"
    />
    <path
      fill="#FFBFA5"
      d="M26 26H8V8h18zm-2-16H10v14h14z"
    />
    <path
      fill="#FF7842"
      d="m13.86 13.41 6.02 18.16 3.05-6.05L31.41 34l3.04-3.03-8.48-8.48 6.05-3.05z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M6.5 8.5H13v1H7.5V15h-1zM17.835 22.158l.95-.316 2.67 8.039 2.309-4.576.892.45-3.391 6.724z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgReageren);

export default ForwardRef;
